import { Grid } from '@mui/material'
import React from 'react'
import globalStyles from "../../../assets/styles/global.module.scss";
import style from "../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss";
import CampaignAnalysis from './campaignAnalysis';

const WhatsappCampaignDashboard = () => {

    return (
        <>
            <Grid item className={`${globalStyles.fullwidth} ${style.campaignPagePadding}`}>
                <Grid container direction={"column"} gap={"24px"}>
                    <Grid item xs={12} sm={12} className={`${style.tableGridItem} ${globalStyles.fullwidth}`}>
                        <CampaignAnalysis
                            getCampaignDataApiCall={() => { }}
                            flagDashboardPage={true}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default WhatsappCampaignDashboard
